// ./src/utils/sanity/client.ts
import { ONE_MONTH_IN_MS } from '@baseball-near-you/common';
import { createClient } from 'next-sanity';

export const sanityClient = createClient({
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID,
  token: process.env.SANITY_API_WRITE_TOKEN,
  dataset: 'production',
  apiVersion: '2025-06-11', // https://www.sanity.io/docs/api-versioning
  useCdn: true, // if you're using ISR or only static generation at build time then you can set this to `false` to guarantee no stale content
});

export const sanityFetch = async <T>(
  query: string,
  tags: string[] = [],
  options?: {
    cache?: boolean;
  }
) => {
  return sanityClient.fetch<T>(
    query,
    {},
    {
      next: {
        tags,
        ...(options?.cache
          ? {
              revalidate: ONE_MONTH_IN_MS / 1000,
              cache: 'force-cache',
            }
          : {
              cache: 'no-store',
            }),
      },
    }
  );
};
